import axiosI from '../Service/service';
import {
    LOGIN,
    LOGOUT,
    GET_USER,
    REGISTER,
    RESET_PASSWORD,
    ENABLE_LOADER,
    DISABLE_LOADER,
} from './actionTypes';
import { ws } from '../App';
import store from '../store';
import { getUnreadCount } from './messagesAction';
import * as constants from '../Constants';

export const loginAction = (credentials) => {
    return (dispatch => {
        return axiosI.post(constants.API.businessLoginApi,
            credentials
        ).then(({data}) => {
            dispatch({
                type: LOGIN,
                payload: data
            });
            if (data.results.ResponseCode && data.results.BusinessUser && data.results.Token) {
                let date = new Date();
                let connection = store.getState().messageReducer.connection;
                if(connection && data.results.AppUser) {
                    ws.json({
                        "token_id": data.results.Token,
                        "user_id": data.results.AppUser.UserId.toString(),
                        "type": "identity",
                        "isOnline": 1,
                        "msgid": date.getTime().toString().slice(4)
                    });
                }
                if(data.results.BusinessUser.PlaceID) {
                    let checkIndata = {
                        "Address": data.results.BusinessUser.Address,
                        "GooglePlaceId": data.results.BusinessUser.PlaceID,
                        "Latitude": data.results.BusinessUser.Address_Lat,
                        "Longitude": data.results.BusinessUser.Address_Long,
                        "PageNumber": 1,
                        "PageSize": 15,
                        "PlaceName": data.results.AppUser.FirstName,
                        "PlaceType": data.results.BusinessUser.Address_Type,
                        "UserId": data.results.AppUser.UserId
                    };
                    userCheckIn(checkIndata);
                    getRecentChat(data.results.AppUser.UserId);
                }
                localStorage.setItem('token', data.results.Token);
                localStorage.setItem('BusinessId', data.results.BusinessUser.BusinessId);
                data.results.AppUser && localStorage.setItem('userFullName', data.results.AppUser.FirstName);
                data.results.AppUser && localStorage.setItem('UserId', data.results.AppUser.UserId);
                getUnreadCount()(dispatch);
            }
             return data;
        }).catch((err) => {
            console.log(err);
        })
    })
};

export const getRecentChat = (userId) => {
    ws.json({
        "user_id": userId.toString(),
        "type": "recentchat",
        "count": 20,
        "index": 1
    });
};

export const resetPasswordAction = (Email) => {
    return (dispatch => {
        return axiosI.post(constants.API.userForgetPasswordApi,
            {Email}
        ).then(({data}) => {
            // console.log(data)
            dispatch({
                type: RESET_PASSWORD,
                payload: data
            });
            return data;
        }).catch((err) => {
            console.log(err);
        })
    })
};


export const logoutAction=()=>{
    return (dispatch => {
        ws.json({
            type:"disconnect",
            userId:localStorage.getItem('UserId'),
            tokenId:localStorage.getItem('token')
        });
        localStorage.clear();
        clearInterval(window.interval);
        dispatch({
            type: LOGOUT
        });
    })
};

export const registerAction=(registerationData)=>{

    return (dispatch => {
        dispatch({ type: ENABLE_LOADER });
        return axiosI.post(constants.API.businessRegistrationApi,
            registerationData
        ).then(({data}) => {
            dispatch({ type: DISABLE_LOADER });
            dispatch({
                type: REGISTER,
                payload: data
            });
            if(data.results.ResponseCode && data.results.BusinessUser) {
                let date = new Date();
                ws.json({
                    "token_id": data.results.Token,
                    "user_id": data.results.AppUser.UserId.toString(),
                    "type": "identity",
                    "isOnline": 1,
                    "msgid": date.getTime().toString().slice(4)
                });
                localStorage.setItem('token', data.results.Token);
                localStorage.setItem('userFullName', data.results.AppUser.FirstName);
                localStorage.setItem('BusinessId', data.results.BusinessUser.BusinessId);
                localStorage.setItem('UserId', data.results.AppUser.UserId);
                let checkIndata = {
                    "Address": data.results.BusinessUser.Address,
                    "GooglePlaceId": data.results.BusinessUser.PlaceID,
                    "Latitude": data.results.BusinessUser.Address_Lat,
                    "Longitude": data.results.BusinessUser.Address_Long,
                    "PageNumber": 1,
                    "PageSize": 15,
                    "PlaceName": data.results.AppUser.FirstName,
                    "PlaceType": data.results.BusinessUser.Address_Type,
                    "UserId": data.results.AppUser.UserId
                };
                userCheckIn(checkIndata);
            }
            return data;
        }).catch((err)=>{
            dispatch({ type: DISABLE_LOADER });
            console.log(err);
        })
    })
};

export const fetchSuggestions=(data)=>{
    return (dispatch => {
        return axiosI.post(constants.API.businessUsernameSuggestionApi, data).then(({data}) => {
            dispatch({
                type: 'FETCH_SUGGESTIONS',
                payload: data
            });
        })
    })
};

export const userCheckIn = (data) => {
    axiosI.post(constants.API.usercheckInApi, data)
    .then((response) => {
        // console.log(response.data);
    })
    .catch((err) => {
        console.log(err);
    });
};

export const userCheckOut = (data) => {
    axiosI.post(constants.API.userCheckoutPlaceApi,data).then((response)=>{
        // console.log(response.data);
    }).catch((err)=>{
        console.log(err);
    });
};

export const userCheckOutWithLogout = (data) => {
    return dispatch =>
        axiosI.post(constants.API.userCheckoutPlaceApi,data).then((response)=>{
            logoutAction()(dispatch);
        }).catch((err)=>{
            console.log(err);
        });
};

export const getUserAction = () => {
    return (dispatch => {
        let id;
        id = localStorage.getItem('UserId') ? localStorage.getItem('UserId') : localStorage.getItem('BusinessId');
        return axiosI.get(`${constants.API.getBusinessDetailsApi}/${id}`).then(({data}) => {
            if (data.results.ResponseCode) {
                localStorage.setItem('userEmail', data.results.AppUser.Email);
                localStorage.setItem('UserId', data.results.AppUser.UserId);
                localStorage.setItem('BusinessId', data.results.BusinessUser.BusinessId);
                //GetRewards(data.results.BusinessUser.PlaceID)(dispatch);
                dispatch({
                    type: GET_USER,
                    payload: data
                });
            }
            else{
                logoutAction()(dispatch);
            }
            return data;
        }).catch((err) => {
            console.log(err);
        })
    })
};

export const enableLoader = () => {
    return dispatch =>
        dispatch({ type:ENABLE_LOADER });
};

export const disableLoader = () => {
    return dispatch =>
        dispatch({ type: DISABLE_LOADER });
};